import PropTypes from 'prop-types';

export const data = PropTypes.shape({
    acceptDeadline: PropTypes.string,
    amount: PropTypes.number,
    fee: PropTypes.number,
    freight: PropTypes.number,
    paymentDeadline: PropTypes.string,
    total: PropTypes.number,
});

export default PropTypes.shape({
    data,
    error: PropTypes.bool,
    loading: PropTypes.bool,
});



// WEBPACK FOOTER //
// ./safeTrade/agreementPropTypes.js